import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import SplashScreen from "../pages/SplashScreen";
import SignIn from "../pages/Auth/Signin";
import OtpScreen from "../pages/Auth/OtpScreen";
import HomePage from "../pages/Home";
import Download from "../pages/Download";
import Help from "../pages/Help";
import GameHistoryPage from "../pages/Help/GameHistory";
import FaqPage from '../pages/Help/Faq'
import Footer from "../components/Footer";
import { logout, useTokenStore } from "../storage/tokenState";
import _isEmpty from "lodash/isEmpty";
import MainLayout from "../Layouts/MainLayout";
import TournamentDetails from "../pages/TournamentDetails";
import GamePlay from "../pages/GamePlay";
import ResultScreen from "../pages/Results";
import HowToPlay from "../pages/HowToPlay";
import { NAVIGATION_ROUTES } from "../constant";
import useQueryParams from "../hooks/useQueryParams";
import { usePreSignupApi } from "../api/usePreSignupApi";
import { setupGoogleTokenRefresh, silentLoginByAuthAPI } from "../services/AuthService";
import { PreSignUpConfig } from "../storage/store";
import { dispatchPreSignupConfig, useConfigStore } from "../storage/configState";
import { setPreSignupConfig } from "../utils/SessionManager";
import { isPlayerOnLudoboard } from "../classes/socket/helper";
import globalSocket from "../classes/socket/mainSocket/GlobalSocket";
import { _get } from "../utils/helpers/zupeeLodash";
import {
  getGameplaySpEventData,
  getToken,
  parseString,
} from "../utils/helpers/common";
import { destroySocket, initializeGameplaySocket } from "../classes/socket/gameplay";
import { JOIN_TOURNAMENT_TABLE, PARTNER_ID } from "../utils/helpers/constants";
import { ExternalLinks } from "../pages/ExternalLinks/ExternalLinks";
import Wallet from "../pages/Wallet";
import Withdraw from "../pages/Withdraw";
import WithdrawStatus from "../pages/WithdrawStatus";
import WithdrawAddMode from "../pages/WithdrawAddMode";
import WithdrawModes from "../pages/WithdrawModes";
import Kyc from "../pages/Kyc";
import Loader from "../components/Loader";
import { useGetGameConfigAPI } from "../api/useGetGameConfigAPI";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { initializeGlobalSocket } from "../classes/socket/mainSocket/SocketService";
import { GOOGLE_LOGIN_KEY, PARTNER_ID_KEY } from "../appConstants/AppConstant";
import { showGoogleLoginModal } from "../store/actions/actions";
import GoogleLoginModal from "../components/GoogleLoginModal";
// import { initializeGlobalSocket } from "../services/SocketService";

const AppRoutes: React.FC = () => {
  // const { isLoggedIn } = useAuth();
  const location = useLocation();
  const pathName = location.pathname;
  const dispatch = useDispatch();
  const className = pathName
    .replace(/^\//, "")
    .split("/")[0]
    .replace(/-$/, "");

  const params = useQueryParams(['partnerId']);
  const partnerIdFromQuery = params?.partnerId;
  const partnerIdFromStorage = localStorage.getItem(PARTNER_ID_KEY);
  const partnerIdFromSession = sessionStorage.getItem(PARTNER_ID_KEY);
  const partnerId = partnerIdFromQuery || partnerIdFromStorage || partnerIdFromSession || PARTNER_ID;

  const { preSignupConfig, error, isLoading, refetch } = usePreSignupApi(partnerId as string);
  const {loginSkipConfig} = preSignupConfig || {};
  const {postSignupConfig} = useConfigStore();
  const [shouldFetchGameConfig, setShouldFetchGameConfig] = useState(false);
  const { isAuthApiResponseStatus } = useSelector((state: RootStateOrAny) => state.appReducer);
  useGetGameConfigAPI(shouldFetchGameConfig); // Pass true to enable the query
  const {
    token: userToken,
    splashConfig: { expiry, backgroundColor, video },
    language,
  } = useTokenStore();
  const accessToken = userToken?.accessToken;
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setShouldFetchGameConfig(true);
    return () => setShouldFetchGameConfig(false);
  }, []);
  // Combined useEffect for handling silent login
  useEffect(() => {
    const handleSilentLogin = async () => {
      // If preSignupConfig exists, skip silent login
      // if (!_isEmpty(preSignupConfig)) {
      //   return;
      // }

      // Silent login for users on ludoboard
      if (navigator?.onLine && isPlayerOnLudoboard()) {
        await silentLoginByAuthAPI(dispatch);
        return;
      }

      // Regular silent login
      await silentLoginByAuthAPI(dispatch);
    };

    // Initial silent login
    handleSilentLogin();

    // Add online/offline event listeners
    const handleOnline = async () => {
      console.log("Network is back online");
      setIsOnline(true);
      await handleSilentLogin(); // Directly trigger silent login when back online
    };

    const handleOffline = () => {
      console.log("Network is offline");
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Cleanup listeners
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []); // Depend only on preSignupConfig

  const handleLogout = () => {
    setLoading(true);
    logout();
  }
  const handleAppClose = () => {
		globalSocket.destroy_socket();
		// gameplaySocket.destroy_socket();
    destroySocket()
		// stopAllSoundElements();
	};

  const handleSocketData = (res: any) => {
    switch (res.en) {
    //   case "SP":
    //     if (res.flag !== true || res.errorCode !== "0000") {
    //       this.props.logout(this.props.history, { error_msg: res.msg });
    //       this.props.hide_loader();
    //       return;
    //     }

    //     const data = _get(res, "data", {});
    //     const {
    //       pp = "",
    //       un = "",
    //       ue = "",
    //       rejoin,
    //       _id = "",
    //       validity = ONE_HOURS_IN_MILISECONDS,
    //       accessToken = "",
    //       signupPhoneNumber = "",
    //       refreshToken,
    //       isNewSignup,
    //     } = data;
    //     if (isNewSignup) {
    //       sendEvents([
    //         { name: GA_EVENTS.GA_SIGNUP },
    //         { name: ADJUST_EVENTS.AE_SIGN_UP },
    //         {
    //           name: CLEVERTAP_EVENTS.EVENT_ON_SIGNUP_LANGUAGE,
    //           params: {
    //             Language: currentLanguage,
    //           },
    //         },
    //       ]);
    //     }

    //     const dataToSave = {
    //       pp,
    //       un,
    //       ue,
    //       accessToken,
    //       signupPhoneNumber,
    //       _id,
    //     };
    //     const token = getToken();
    //     if (_isEmpty(token)) {
    //       // manual login by user
    //       sendEvents([
    //         {
    //           name: CLEVERTAP_EVENTS.EVENT_LOGIN,
    //           params: {
    //             [USER_LOGIN_TYPE]: "MOBILE_OTP",
    //             [SERIAL_NUMBER]: SP_RANDOM_SERIAL,
    //           },
    //         },
    //         { name: ADJUST_EVENTS.AE_SIGN_IN },
    //       ]);
    //     }
    //     if (!refreshToken) {
    //       dataToSave.refreshToken = token.refreshToken;
    //     } else {
    //       dataToSave.refreshToken = refreshToken;
    //     }
    //     setToken(dataToSave);
    //     setAppLanguage(getAppLanguage());
    //     if (typeof validity === "number" && !timer_login_interval) {
    //       timer_login_interval = setInterval(() => {
    //         if (!accessToken) {
    //           clearInterval(timer_login_interval);
    //           timer_login_interval = false;
    //           return;
    //         }
    //         this.hitSpEvent();
    //       }, validity - 60000);
    //     }
    //     this.props.setInitialUserDetail(data); // we are setting the initial user data
    //     this.props.setUserLoggedIn();
    //     this.props.fetchUserDetails(); // we need to fetch the complete user data

    //     if (rejoin === 1) {
    //       gameplaySocket.initialize(
    //         _get(res, "data.gameplayServer", EMPTY_OBJECT),
    //         this.props,
    //         () => {
    //           gameplaySocket.emit(
    //             parseString({ en: "RJT", data: { _id, gt: "normal" } })
    //           );
    //         }
    //       );
    //     } else {
    //       if (this.props.history.location.pathname === ROUTES.LUDOBOARD) {
    //         this.props.history.push(ROUTES.HOME);
    //       }
    //       this.props.hide_loader();
    //     }

    //     break;
      case "CONNECTION_MANAGE": {
        // this.handleNewConnection();
        handleAppClose();
        setTimeout(()=>{
          handleLogout()
        }, 1000);
        break;
      }
    //   case "TOURNAMENT_STARTED":
    //     if (this.props.history.location.pathname !== ROUTES.LUDOBOARD) {
    //       this.props.history.push({
    //         pathname: ROUTES.COUNTDOWN,
    //         state: {
    //           timer: _get(res, "data.timer"),
    //           ltid: _get(res, "data.ltid"),
    //         },
    //       });
    //     }
    //     break;

    
      case "GAME_STARTED":
        // initializeGameplaySocket.initialize(
        //   _get(res, "data.gameplayServer", EMPTY_OBJECT),
        //   this.props,
        //   () => {
        //     gameplaySocket.emit(
        //       parseString({ en: "JOIN_TOURNAMENT_TABLE", data: res.data })
        //     );
        //   }
        // );
        initializeGameplaySocket(res?.data?.gameplayServer, {
          en: JOIN_TOURNAMENT_TABLE,
          data: { ltid: res?.data?.ltid },
        });
        break;
    //   case "GET_USER_DETAILS": {
    //     const data = _get(res, "response.userDetail", EMPTY_OBJECT);
    //     this.props.setUserDetails(data);
    //     break;
    //   }
      default:
        break;
    }
  };

  const hitSpEvent = () => {
    globalSocket.emit(parseString(getGameplaySpEventData()));
  };

  const onSocketConnected = () => {
    // token helper
    const token = getToken();
    if (!_isEmpty(_get(token, "accessToken", ""))) {
      //access token is used to check if user is authorised
      hitSpEvent();
    } else {
      // this.props.logout(this.props.history); //for safe side we are removing the token and we are sending to login page
      // this.props.hide_loader();
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (!_isEmpty(loginSkipConfig)) {
        if (loginSkipConfig?.enabled) {
          setupGoogleTokenRefresh();
          if (_isEmpty(sessionStorage.getItem(GOOGLE_LOGIN_KEY))) {
            console.log("showGoogleLoginModal ========>>>");
            dispatch(showGoogleLoginModal());
          }
        } else if (!loginSkipConfig?.enabled) {
          sessionStorage.removeItem(GOOGLE_LOGIN_KEY);
          sessionStorage.removeItem(PARTNER_ID_KEY);
        }
      }
    }, 0);
  }, [loginSkipConfig?.enabled, dispatch, loginSkipConfig]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (isOnline && !_isEmpty(postSignupConfig) && !_isEmpty(userToken) && isAuthApiResponseStatus) {
        const socket = initializeGlobalSocket(postSignupConfig, {
          onLogout: handleLogout
        });
        return () => socket.destroy();
      }
    }, 1000);
    
    return () => {
      clearTimeout(timer);
    };
  }, [isOnline, postSignupConfig, userToken, isAuthApiResponseStatus]);

  if(loading) return <Loader transparent/>

  return (
    <div className={`${className}-page`} style={{ height: "100%" }}>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<SplashScreen />} />
        {_isEmpty(userToken) ? (
          <>
            <Route path={NAVIGATION_ROUTES.SIGNIN} element={<SignIn />} />
            {/* <Route path="/otp/:phoneNumber/:action" element={<OtpScreen />} /> */}
            <Route
              path={`${NAVIGATION_ROUTES.OTP}/:phoneNumber/:action`}
              element={<OtpScreen />}
            />
          </>
        ) : (
          <Route
            path={NAVIGATION_ROUTES.SIGNIN}
            element={<Navigate to={NAVIGATION_ROUTES.WALLET} replace />}
          />
        )}
        <Route element={<MainLayout />}>
          <Route path={NAVIGATION_ROUTES.HOME} element={<HomePage />} />
          <Route path={NAVIGATION_ROUTES.DOWNLOAD} element={<Download />} />
          <Route path={NAVIGATION_ROUTES.HELP} element={<Help />} />
        </Route>

        {/* for non-footer pages */}
        <Route path={NAVIGATION_ROUTES.HOW_TO_PLAY} element={<HowToPlay />} />
        {/* <Route path="/tournament-details/:tabName" element={<TournamentDetails />} /> */}
        <Route
          path={`${NAVIGATION_ROUTES.TOURNAMENTDETAILS}/:tabName`}
          element={<TournamentDetails />}
        />
        <Route path={NAVIGATION_ROUTES.GAMEPLAY} element={<GamePlay />} />
        <Route
          path={NAVIGATION_ROUTES.GAMEHISTORY}
          element={<GameHistoryPage />}
        />
        <Route 
          path={NAVIGATION_ROUTES.FAQS}
          element={<FaqPage/>}/>
        <Route
          path={NAVIGATION_ROUTES.WINNER_SCREEN}
          element={<ResultScreen />}
        />

        {/* Wallet is public: logged-out users see a ₹0 balance and the CTA
            sends them to sign-in. Withdrawal itself stays gated below. */}
        <Route path={NAVIGATION_ROUTES.WALLET} element={<Wallet />} />

        {/* Withdrawal — logged-in only */}
        <Route
          path={NAVIGATION_ROUTES.WITHDRAW}
          element={
            _isEmpty(userToken) ? (
              <Navigate to={NAVIGATION_ROUTES.SIGNIN} replace />
            ) : (
              <Withdraw />
            )
          }
        />
        <Route
          path={NAVIGATION_ROUTES.WITHDRAW_ADD_MODE}
          element={
            _isEmpty(userToken) ? (
              <Navigate to={NAVIGATION_ROUTES.SIGNIN} replace />
            ) : (
              <WithdrawAddMode />
            )
          }
        />
        <Route
          path={NAVIGATION_ROUTES.KYC}
          element={
            _isEmpty(userToken) ? (
              // Carry the full path INCLUDING the query string: DigiLocker returns
              // here with ?client_id=..., and the backend registers no webhook, so
              // dropping it loses the verification with no way to ever complete it.
              <Navigate
                to={NAVIGATION_ROUTES.SIGNIN}
                replace
                state={{ returnTo: `${location.pathname}${location.search}` }}
              />
            ) : (
              <Kyc />
            )
          }
        />
        <Route
          path={NAVIGATION_ROUTES.WITHDRAW_MODES}
          element={
            _isEmpty(userToken) ? (
              <Navigate to={NAVIGATION_ROUTES.SIGNIN} replace />
            ) : (
              <WithdrawModes />
            )
          }
        />
        <Route
          path={NAVIGATION_ROUTES.WITHDRAW_STATUS}
          element={
            _isEmpty(userToken) ? (
              <Navigate to={NAVIGATION_ROUTES.SIGNIN} replace />
            ) : (
              <WithdrawStatus />
            )
          }
        />
        {/* Protected Routes */}
        {/* <Route element={<ProtectedRoute isLoggedIn={isLoggedIn} />}>
          
        </Route> */}

        {/* A client-side arrival at the DigiLocker return path. A top-level
            arrival never gets here — `bootstrapKycReturn` resolves it before the
            app mounts. Carries the query string, unlike the catch-all below. */}
        <Route
          path={NAVIGATION_ROUTES.KYC_CALLBACK}
          element={
            <Navigate
              to={`${NAVIGATION_ROUTES.KYC}${location.search}`}
              replace
            />
          }
        />

        {/* Redirect to login if route is not found */}
        <Route
          path="*"
          element={<Navigate to={NAVIGATION_ROUTES.WALLET} replace />}
        />
        <Route path={NAVIGATION_ROUTES.EXTERNAL_LINKS} element={<ExternalLinks/>}/>
      </Routes>

      {/* Conditionally render the footer outside of <Routes> */}
      {/* {isLoggedIn && <Footer />} */}
      <GoogleLoginModal />
    </div>
  );
};

export default AppRoutes;
